.statusDot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: var(--radius-circle);
  /* Figma spec: --green-500 (#10b981) in light, --green-400 (#34d399)
   * in dark. The existing --semantic-success token uses #10b981 in
   * BOTH light and dark mode, so plugging it in would silently lose
   * the dark-mode shift to #34d399. Hardcode both literals here until
   * design exposes a dedicated --status-dot-color alias that carries
   * the correct per-mode values — then swap the two literals in one
   * pass. Do NOT "simplify" this to var(--semantic-success): that
   * token stays at #10b981 in dark mode and would break the shift. */
  background: #10b981;
  flex-shrink: 0;
  /* Small primitive: no transition. Color change on theme toggle is
   * handled by the [data-theme="dark"] override below and happens
   * instantly, matching every other token-driven theme swap. */
}

/* TODO: remove when --status-dot-color semantic alias lands. */
[data-theme="dark"] .statusDot {
  background: #34d399;
}
